import { ReportVariableTypeEnum } from '../enums/report-variable-type.enum';

export class ReportVariableDto {
	key!: string;
	type!: ReportVariableTypeEnum;
	value?: any;
	isArray?: boolean;
}
